import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from "@angular/material";
import { OrderEventsService } from "../../../core/e-commerce/_services";
import { finalize } from "rxjs/operators";
import { InfoComponent } from "../info/info.component";
import { AlertComponent } from "../alert/alert.component";
import { CampaignService } from "../../../core/services/campaign.service";
import { saveAs } from 'file-saver';
import { UIPermissionWrapper } from '../../../model/ui-permission-wrapper.model';
import { FrontendService } from '../../../service/frontend.service';

@Component({
  selector: 'kt-dialog-credit-notes',
  templateUrl: './dialog-credit-notes.component.html',
  styleUrls: ['./dialog-credit-notes.component.scss']
})
export class DialogCreditNotesComponent implements OnInit {

  @ViewChild('zone') zone;
  campaigns;
  campaignSelected;
  loading;

  public permission: UIPermissionWrapper;

  constructor(
      private dialog: MatDialog,
      private orderEventsService: OrderEventsService,
      private cdr: ChangeDetectorRef,
      public dialogRef: MatDialogRef<DialogCreditNotesComponent>,
      private campaignService: CampaignService,
      private frontendService: FrontendService) {}

  ngOnInit() {
      this.permission = this.frontendService
        .permissionFor("views/shared/dialog-credit-notes/dialog-credit-notes.component");
      this.getCampaigns();
  }

    getCampaigns() {
        this.campaignService.getCampaigns().subscribe(res => {
            this.campaigns = res;
            // this.loading = false;
            this.cdr.detectChanges();
        }, error1 => {
            console.log(error1);
        });
    }
    onNoClick(): void {
        this.dialogRef.close(false);
    }

    exportZone() {
        let data = {
            zone: this.zone.nativeElement.value,
            campaignId: this.campaignSelected
        };
        this.exportExcel(this.orderEventsService.downloadEventsZone(data), 'eventsZone.xlsx');
    }

    export() {
        let data = {
            zone: this.zone.nativeElement.value,
            campaignId: this.campaignSelected
        };
        this.exportExcel(this.orderEventsService.downloadEvents(data), 'events.xlsx');
    }

    exportExcel(request, filename) {
        request
            .subscribe(
                success => {
                    saveAs(success, filename);
                },
                () => {
                    alert('Error al descargar el archivo.');
                }
            );
    }

    importReseller($event) {
        let data = {
        };
        this.importExcel(this.orderEventsService.importResellers($event.target.files[0], data));
    }

    importZone($event) {
        let data = {
            zone: this.zone.nativeElement.value,
            campaignId: this.campaignSelected
        };
        this.importExcel(this.orderEventsService.importZone($event.target.files[0], data));
    }

    importExcel(request) {

        this.loading = true;
        this.cdr.detectChanges();
        request.pipe(finalize(() => {
            // this.myInputVariable.nativeElement.value = '';
        })).subscribe(
            response => {
                this.dialog.open(InfoComponent, {
                    width: '400px',
                    data: {
                        mensaje: response['message'],
                        title: 'Éxito'
                    }
                });
                this.loading = false;
                this.cdr.detectChanges();
            },
            error => {
                this.loading = false;
                this.cdr.detectChanges();
                this.dialog.open(AlertComponent, {
                    width: '400px',
                    data: {
                        mensaje: error.error,
                        title: 'Error'
                    }
                });
            });
    }

    campaignChange(event) {
        this.campaignSelected = event.value;
    }
}
